import { RouteSettingBoard } from '../components/route-setting-board/RouteSettingBoard';

/** The routes half of the route-setting kanban. */
export default function RoutesBoardPage() {
  return <RouteSettingBoard climbType="route" />;
}
